import React from 'react';
import Alert from '@material-ui/lab/Alert';
import { marginBottom } from "../../../config/styles";

export default function NoItemFoundAlert({ type }) {
    let item = 'item';
    return (
        <>
            <Alert id={"no-item-alert"} icon={false} severity="info" style={marginBottom}>{`No ${type != undefined ? type : item}`}</Alert>
        </>
    )
}
